<template>
  <div class="command-col">
    <br><h3 class="command-name">.{{ command.help.name }}</h3>
    <p class="form-field-title-description">{{ command.help.description }}</p>
    <p class="command-details">
      ❓ Usage: <code>.{{ command.help.name }} {{ command.help.usage ? ` ${command.help.usage}` : "" }}</code><br>
      📁 Aliases: <b>{{ command.conf.aliases.length ? command.conf.aliases.join(", ") : "No aliases" }}</b><br>       
      🛡️ Required Permission: <b>{{ command.conf.permLevel }}</b><br>
      ⏱️ Cooldown: {{ ms(command.conf.cooldown * 1000, { long: true }) }}
    </p>
  </div>
</template>

<script>
import ms from "ms"

export default {
  name: "CommandCard",
  props: ["command"],
  data () {
    return {
      ms
    }
  }
}
</script>

<style scoped>  
  .command-col {
    display: inline-block;
    width: 40%;
    height: 210px;
    margin: 5px 10px;
    background-color: var(--light-grey-blue);
    border-radius: 3px;
    -webkit-box-shadow: 10px 10px 16px -5px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 10px 10px 16px -5px rgba(0, 0, 0, 0.2);
    box-shadow: 10px 10px 16px -5px rgba(0, 0, 0, 0.2);
    transition: .3s ease;
    overflow: hidden;
    padding: 0 50px;
    transform: translateY(150px);
    opacity: 0;
    animation: come-in 0.6s ease forwards;
  }

  .command-col:hover {
    transform: scale(1.04);
    z-index: 100;
  }

  @media screen and (max-width: 720px) {
    .command-col {
      width: 80%;
    }
  }

  .command-name {
    font-size: 20px;
  }

  .command-details {
    transition: .4s ease;
  }

  .command-col:hover .command-details {
    filter: none;
  }

  .command-col code {
    background: #1a1a1a;
    font-size: 15px;
    padding: 2px;
  }
</style>